type Props = {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
};

export default function KpiTile({ label, value, sub }: Props) {
  return (
    <div className="ds-kpi">
      <div className="ds-kpi-label">{label}</div>
      <div className="ds-kpi-value">{value}</div>
      {sub && <div className="ds-kpi-sub">{sub}</div>}
    </div>
  );
}
